export default "/images/vendor/flag-icons/flags/4x3/cx.svg?1d486e07716508b2e944c433c4c1d596";